import React, { useMemo, useState } from 'react';
import { Icon } from '@doxyme/ui';
import { useIntl } from 'react-intl';
import { LocationsGroupAccessModal } from '../locations-group-access-modal/locations-group-access-modal';
export const LocationsGroupAccessButton = ({ location }) => {
    const intl = useIntl();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const locationName = useMemo(() => location.name, [location.name]);
    const label = intl.formatMessage({
        id: 'account.settings.locations.group-access.manage',
    });
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setIsModalOpen(true);
        }
    };
    return (<>
      <div className="locations__table_button-cell">
        <div className="locations__table_button-cell__icon" onClick={() => setIsModalOpen(true)} onKeyDown={handleKeyDown} role="button" tabIndex={0} aria-label={label}>
          <Icon name="group2" size="x-small"/>
        </div>
      </div>

      <LocationsGroupAccessModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} locationId={location.id} locationName={locationName}/>
    </>);
};
